import { FC } from 'react';
import { useBranding } from '@utils/api';
import LanguageSelector from '@/components/common/LanguageSelector';
import { Separator } from '@/components/ui/separator';

type WizardHeaderProps = {
  currentStep: string;
  supportedLanguages?: string[];
  hasPreSelectedService: boolean;
};

const WizardHeader: FC<WizardHeaderProps> = ({ currentStep, supportedLanguages, hasPreSelectedService }) => {
  const { branding } = useBranding();

  if (!branding) return null;

  // Show language selector on serviceSelection when no service was pre-selected
  // (pre-selected services show it in the FormWizard on the first question)
  const showLanguageSelector = supportedLanguages &&
    !hasPreSelectedService && currentStep === 'serviceSelection';

  return (
    <>
      <div className="w-full flex items-center justify-between">
        { }
        <img
          className="text-center object-contain max-w-full h-14 sm:h-20 flex-1"
          alt={`${branding.name}'s Logo`}
          src={branding.logo}
        />
      </div>
      <Separator aria-hidden='true' className='mb-2' />

      {showLanguageSelector && (
        <LanguageSelector supportedLanguages={supportedLanguages} />
      )}
    </>
  );
};

export default WizardHeader;
